import { render } from "./df-percent-cell.vue?vue&type=template&id=2a63b584"
import script from "./df-percent-cell.vue?vue&type=script&lang=js"
export * from "./df-percent-cell.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__